// extracted by mini-css-extract-plugin
module.exports = {"form-input":"_2whQRx8Z","is-disabled":"_1tHxkZWq"};